<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container" v-if="hasNoProject">
        <div class="row">
          <h4 class="not-found">Desculpe! Projeto inexistente ou não disponível.</h4>
          <div class="not-found-back">
          <router-link to="/projects">Ir para Lista de ONGs</router-link>
          </div>
        </div>
      </div>
      <div class="project-header" v-if="project">

        <div class="container">
          <div class="row">

            <div class="col-md-12">
              <div class="breadcrumb-list">
                <ul>
                  <li><router-link to="/projects">PROJETOS</router-link></li>
                  <li v-if="project && project.projectType != 'event' && project.Categories[0].name" class="category">
                    <router-link :to="'/projects/' + project.Categories[0].url">{{project.Categories[0].name.toUpperCase()}}</router-link></li>
                  <li v-if="project && project.projectType != 'event' && !project.Categories[0].name && project.Categories[1].name" class="category">
                    <router-link :to="'/projects/' + project.Categories[1].url">{{project.Categories[1].name.toUpperCase()}}</router-link></li>
                  <li class="active">{{(project) ? project.Info.title : null}}</li>
                </ul>
                <div class="button" v-if="isAuth && (user.isAdmin || user.profile != 'ong')">
                  <a class="favorite" href="" @click.stop.prevent="markAsFavorite()">{{(!isFavorite) ? 'Seguir Projeto' : 'Seguindo'}} <font-awesome-icon :icon="[(!isFavorite) ? 'far' : 'fas', 'heart']" size="lg" /></a>
                </div>
              </div>
            </div>

            <div class="col-md-7">
              <div class="project-content">
                <carousel class="carousel" :autoplay=false :perPage=1 :paginationEnabled=true :autoplayHoverPause=true :loop=true :autoplayTimeout=5000>

                  <slide class="slide" v-if="project && (project.Info.video || project.Info.videoUrl)">
                    <div class="embed-container">
                      <iframe :src="video" frameborder="0" allowfullscreen></iframe>
                    </div>
                  </slide>

                  <slide class="slide">
                    <div class="embed-container">
                      <img :src="(project.Info.image && project.Info.image.length > 0 && project.Info.image.search('via.placeholder.com') == -1) ? project.Info.image : 'https://via.placeholder.com/800x500&text=Sem+Foto'"/>
                    </div>
                  </slide>

                  <slide class="slide" v-if="project.Images" v-for="(img, k) in project.Images" :key="k">
                    <div class="embed-container">
                      <img :src="img.url"/>
                    </div>
                  </slide>

                </carousel>


              </div>
            </div>

            <div class="col-md-5">
              <div class="project-action">
                <h2>{{(project) ? project.Info.title : null}}</h2>

                <div class="person-name" v-if="project.Manager">
                  <ul class="person-social">
                    <li><p>{{project.Manager.name}} {{project.Manager.organization}}</p></li>
                    <li><a href="" class="contact">Contato</a></li>
                    <li><p><i class="fa fa-map-marker"></i>{{project.Manager.address}} {{project.Manager.hood}} {{project.Manager.city}} </p></li>
                  </ul>
                </div>

                <div class="donations" v-if="project.Donations">
                    <span class="price-donation">{{getDonationsValue()}}</span>
                    <p class="text-right">de <span>{{project.Donations.length}}</span> doador(es)</p>
                </div>



                <div class="actions row" v-if="project">
                  <div class="button donation">
                    <a class="donate" href="" v-on:click.stop.prevent="donate()" v-if="user.isAdmin || user.profile != 'ong'">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" size="lg" /> Doar
                    </a>
                  </div>
                  <div class="button donation" v-if="isAuth">
                    <a class="donate-click" href="" v-on:click.stop.prevent="donateQuickly()" v-if="user.isAdmin || user.profile != 'ong'">
                      <font-awesome-icon :icon="['fas', 'dollar-sign']" size="lg" /> Doe com um Clique
                    </a>
                  </div>


                </div>
                <div class="actions sharing row">
                  <div class="button">
                    <a class="share-facebook" href="" v-on:click.stop.prevent="facebookShare()">
                      <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /> Compartilhe
                    </a>
                  </div>
                  <div class="button">
                    <a class="share-whatsapp" href="" v-on:click.stop.prevent="whatsappShare()">
                      <font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" /> Compartilhe
                    </a>
                  </div>
                  <!-- <div class="button">
                    <a class="discounts" :href="'/d/' + project.slug" target="_blank">
                      <font-awesome-icon :icon="['fas', 'gift']" size="lg" /> Descontos Do Bem
                    </a>
                  </div> -->
                </div>
                <div class="actions row">
                  <!-- <div class="button">
                    <a class="share-facebook" href="" v-on:click.stop.prevent="facebookShare()">
                      <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /> Compartilhe
                    </a>
                  </div>
                  <div class="button">
                    <a class="favorite" href="" v-on:click.stop.prevent="markAsFavorite()"><font-awesome-icon :icon="[(!isFavorite) ? 'far' : 'fas', 'heart']" size="lg" /></a>
                  </div> -->
                  <!-- <div class="button">
                    <a class="share-email" href=""><font-awesome-icon :icon="['far', 'envelope']" size="lg" /></a>
                  </div> -->
                </div>

                <div class="project-ods" v-if="ODS && ODS.length > 0">
                  <h2>Objetivos de Desenvolvimento Sustentável</h2>
                  <div class="row">
                    <carousel class="carousel" :autoplay=true :perPage=4 :paginationEnabled=false :autoplayHoverPause=true :loop=true :autoplayTimeout=3000>
                      <slide class="slide col-md-3" v-for="(slug, i) in ODS" :key="i">
                          <a target="_blank" :href="getODS(slug).url">
                            <img :src="getODS(slug).image"/>
                          </a>
                      </slide>
                    </carousel>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="project-body" v-if="project">
        <div class="container">
          <div class="row">

            <div class="col-md-7">

              <div class="project-description">
                <h2>Nosso projeto</h2>
                <p v-html="(project) ? project.Info.description : null">
                </p>
              </div>

              <!-- <div class="project-ods" v-if="project.ODS && project.ODS.length > 0">
                <h2>Objetivos de Desenvolvimento Sustentável</h2>
                <div class="row">
                  <div v-for="(slug, i) in project.ODS" :key="i" class="col-md-3">
                    <a target="_blank" :href="getODS(slug).url">
                      <img :src="getODS(slug).image"/>
                    </a>
                  </div>
                </div>
              </div> -->

              <div class="project-share">
                <h2>Compartilhe este projeto</h2>
                <button class="btn facebook-share" @click.stop.prevent="facebookShare()">
                  <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /> Facebook
                </button>
                <!-- <button class="btn email-share">
                  <font-awesome-icon :icon="['far', 'envelope']" size="lg" /> E-mail
                </button> -->
              </div>

              <div class="project-activities" v-if="project.Activities">
                <h2>Atividades <b>{{project.Activities.length}}</b></h2>
                <div class="activity" v-for="(a, k) in project.Activities" :key="k">
                  <h4>{{a.title}}</h4>
                  <div v-html="a.text"></div>
                  <span>{{getTimeAgo(a.timestamp)}}</span>
                </div>
              </div>

              <div class="project-comments">
                <h2>Comentários</h2>
                <!-- Your embedded comments code -->
                <!-- <div class="fb-comments"
                  :data-href="'https://click2giv.com/#/project/' + project.slug"
                  data-width="500"></div> -->
                <vue-disqus shortname="https-click2giv-com" :identifier="slug" :url="'https://click2giv.com/project/' + slug"></vue-disqus>
              </div>

            </div>

            <div class="col-md-5">
              <div class="project-donations" v-if="project && donationsList && donationsList.length > 0">
                <h2>Doadores <b>{{project.Donations.length}}</b></h2>
                <ul>
                  <li class="row" v-for="donation in donationsList" :key="donation.DonationId">
                    <div class="col-md-3">
                      <img v-if="!donation.visibility && donation.picture" :src="donation.picture"/>
                      <img class="no-user" v-else :src="noUser"/>
                    </div>
                    <div class="col-md-9">
                      <span>{{convertToReal(donation.value)}}</span>
                      <p v-if="!donation.visibility && donation.name">{{donation.name}}</p>
                      <p v-else><i>Doação Anônima</i></p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
    <b-modal ref="mustLogin" hide-footer title="Perfil não autorizado">
      <div class="d-block text-center">
        <h5>Olá! O seu perfil de 'ONG' não permite realizar doações.</h5>
      </div>
      <!-- <b-btn class="mt-3" variant="outline-success" block @click="goToLogin">Entrar</b-btn> -->
      <!-- <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Fechar</b-btn> -->
    </b-modal>

    <b-modal :ok-only="true" size="md" ok-title="Processar Doação" id="userDonationModal" ref="userDonationModal" title="Informe um valor a ser doado" @ok="submitFormDonation">
      <form method="post" class="donationForm" ref="formPayment">


        <div class="row">

          <div class="col-md-12">
            <div class="form-group">
              <label>Valor de Doação</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">R$</span>
                </div>
                <input required type="text" v-money="money" name="value" placeholder="Informe o valor que deseja doar para o projeto" v-model="donationValue" class="form-control input-value"/>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Mensagem</label>
              <input type="text" name="message" placeholder="Escreva uma mensagem para a equipe do projeto" v-model="donationMessage" class="form-control"/>
            </div>
          </div>

        </div>
        <div v-if="donationModalMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{donationModalMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" @click.stop.prevent="hideMsg()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

      </form>
    </b-modal>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faDollarSign, faGift} from '@fortawesome/fontawesome-free-solid'
import {faEnvelope, faHeart} from '@fortawesome/fontawesome-free-regular'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import auth from '../services/auth'
import Loading from './includes/Loading'
import Functions from '../utils/functions'
import { API } from '../services/api'
import ods1 from '../assets/images/onu/1.png'
import ods2 from '../assets/images/onu/2.png'
import ods3 from '../assets/images/onu/3.png'
import ods4 from '../assets/images/onu/4.png'
import ods5 from '../assets/images/onu/5.png'
import ods6 from '../assets/images/onu/6.png'
import ods7 from '../assets/images/onu/7.png'
import ods8 from '../assets/images/onu/8.png'
import ods9 from '../assets/images/onu/9.png'
import ods10 from '../assets/images/onu/10.png'
import ods11 from '../assets/images/onu/11.png'
import ods12 from '../assets/images/onu/12.png'
import ods13 from '../assets/images/onu/13.png'
import ods14 from '../assets/images/onu/14.png'
import ods15 from '../assets/images/onu/15.png'
import ods16 from '../assets/images/onu/16.png'
import ods17 from '../assets/images/onu/17.png'
import noUser from '../assets/images/no_user.png';
import {VMoney} from 'v-money';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Project',
  directives: {money: VMoney},
  components: {
    Header,
    Footer,
    FontAwesomeIcon,
    Loading,
    Carousel,
    Slide
  },
  data () {
    return {
      loading: true,
      project: null,
      ProjectId: null,
      minimumValue: 20,
      isFavorite: false,
      hasNoProject: false,
      donatinsList: null,
      ODS: null,
      arrODSImages: [ods1, ods2, ods3, ods4, ods5, ods6, ods7, ods8, ods9, ods10, ods11, ods12, ods13, ods14, ods15, ods16, ods17],
      video: null,
      user: false,
      slug: null,
      donationMessage: '',
      donationModalMsgShow: false,
      donationModalMsg: '',
      donationValue: 0,
      integralDonationValue: 0,
      msg: '',
      msgShow: false,
      noUser: noUser,
      isAuth: auth.isAuth(),
      metaInfos: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  metaInfo() {
      return {
        title: this.project ? this.project.Info.title + ' - Click2giv' : 'Click2giv',
        meta: [
          { property: 'og:title', content: this.project ? this.project.Info.title : 'Click2giv' },
          { property: 'og:type', content: 'article' },
          { property: 'og:description', content: this.project ? this.project.Info.shortDescription : '' },
          { property: 'og:image', content: this.project ? this.project.Info.image : '' },
          { property: 'og:url', content: this.project ? 'https://click2giv.com/project/' + this.slug : '' },
        ]
      }
  },
  created (){
    this.slug = this.$route.params.slug;
    this.loadProject();
  },
  mounted (){

  },
  methods: {
    loadUserToFavorite()
    {
      var project = this.project;
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
        this.user = response.body.user;
        if(this.user.favoritedProjects){
          var projectFavorited = this.user.favoritedProjects.filter((p) => {
            return p == project.ProjectId;
          })
          if(projectFavorited[0]){
            this.isFavorite = true;
          }
        }
        this.loading = false;
      });
    },
    loadProject(){
      this.$http.get(API.Projects.getProject + this.$route.params.slug).then((res) => {
        this.project = res.body[0];

        if(auth.isAuth()){
          this.loadUserToFavorite();
        }else{
          this.loading = false;
        }

        this.donationsList = this.project.Donations;
        if(this.donationsList){
          this.donationsList.sort(function(x, y){
            return y.timestamp - x.timestamp;
          })
          // this.donationsList = this.donationsList.filter(d => {
          //   return !d.visibility && d.name;
          // })
          this.donationsList = this.donationsList.slice(0, 10);
        }
        if(this.project.ODS && this.project.ODS.length > 0){
          this.ODS = this.project.ODS;
          // this.ODS.splice(4);
        }
        this.minimumValue = (this.project.minimumValue) ? this.project.minimumValue : 20;
        this.$router.push('/project/' + this.project.slug)
        this.getVideoUrl();
      }, (err) => {
        this.loading = false;
        this.hasNoProject = true;
      })
    },
    getVideoUrl(){
      var videoUrl = (this.project.Info.video) ? this.project.Info.video : this.project.Info.videoUrl;
      if(videoUrl){
        var type = (videoUrl.search('youtu') !== -1) ? 'youtube' : 'vimeo';
        if(type == 'vimeo'){
          var id = videoUrl.split("com/")
          this.video = 'https://player.vimeo.com/video/' + id[1] + '?badge=0&portrait=0&autoplay=0&byline=0&title=0';
        }else{
          if(videoUrl.search('youtube.com/embed/') !== -1){
            this.video = videoUrl;
          }else{
            var id = videoUrl.split("?v=")
            if(!id[1]){
              id = videoUrl.split("be/");
            }
            this.video = 'https://www.youtube.com/embed/' + id[1] + '?rel=0&controls=1showinfo=0&modestbranding=1';
          }
        }
      }
    },
    donate(){
      if(this.user && this.user.profile == 'ong'){
        this.$refs.mustLogin.show()
      }else{
        this.$router.push('/project/donation/' + this.project.slug);
      }
    },
    goToLogin(){
      auth.logout();
      this.$router.push('/login-and-redirect/' + this.project.slug);
      this.$refs.mustLogin.hide()
    },
    hideModal(){
      this.$refs.mustLogin.hide()
    },
    facebookShare(){
      FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
          object: {
            'og:url': 'https://click2giv.com/project/' + this.project.slug,
            'og:title': this.project.Info.title,
            'og:description': this.project.Info.shortDescription,
            'og:image': this.project.Info.image
          }
        })
      }, function(response){});
    },
    whatsappShare(){
      window.open('https://api.whatsapp.com/send?text=https://click2giv.com/project/' + this.project.slug);
    },
    getDonationsValue(){
      var value = 0.0;
      this.project.Donations.map((d) => {
        value += parseFloat(d.value);
      })
      return Functions.numberToReal(value)
    },
    convertToReal(value){
      value = parseFloat(value)
      if(value){
        return Functions.numberToReal(value)
      }
      return value;
    },
    markAsFavorite(){
      if(this.isFavorite){
        this.isFavorite = false;
      }else{
        this.isFavorite = true;
      }
      if(auth.isAuth()){
        this.$http.post(API.Projects.favoriteProject + this.project.ProjectId, null, {headers: auth.getHeaders()}).then((res) => {
          if(res.body.success == false){
          }
        }, (err) => {
            this.isFavorite = !this.isFavorite;
            alert("Erro ao favoritar projeto!");
        });
      }else{
        this.$refs.mustLogin.show()
      }
    },
    getODS(slug){
      var odsList = Functions.getOdsList();
      var ods = odsList.filter((o) => {
        return o.slug == slug;
      })

      var ods = ods.map((o) => {
        return {
          ...o,
          image: this.arrODSImages[o.number - 1]
        }
      })
      return ods[0]
    },
    getTimeAgo(timestamp)
    {
      return Functions.timeDifference(timestamp)
    },
    donateQuickly(){
      if(this.user && this.user.profile == 'ong'){
        this.$refs.mustLogin.show()
      }else{
        this.ProjectId = this.project.ProjectId;
        this.$refs.userDonationModal.show();
      }
    },
    submitFormDonation(e)
    {
      e.preventDefault();

      this.loading = true;
      var donationValueText = parseFloat(this.donationValue.replace(".", "").replace(",", "."));
      this.integralDonationValue = (donationValueText > 0.0) ? donationValueText : this.donationValue;
      if(this.minimumValue <= this.integralDonationValue){
        if(this.integralDonationValue){
          this.$refs.userDonationModal.hide();
          this.$http.post(API.Invite.registerDonation, {
            ProjectId: this.ProjectId,
            donationValue: this.integralDonationValue,
            message: this.donationMessage,
          }).then((res) => {
            this.loading = false;
            var DonationId = res.body.DonationId;
            this.methodPagarme(DonationId);
          });
        }else{
          this.loading = false;
          this.donationModalMsg = 'Você deve definir um valor e uma mensagem para a doação!';
          this.donationModalMsgShow = true;
        }
      }else{
        this.loading = false;
        this.donationModalMsg = 'Valor mínimo de doação é R$' + this.minimumValue + '!';
        this.donationModalMsgShow = true;
      }
    },
    methodPagarme(DonationId){
      var $this = this;
      // inicia a instância do checkout
      var checkout = new PagarMeCheckout.Checkout({
        encryption_key: 'ek_live_eMgIJ1T98Ru5U0K8hDHHkwRp8yLisM',
        // encryption_key: 'ek_test_BGBezpiqx7ZKxMAvh2d7azSUDrNZBo',
        success: function(data) {
          $this.loading = true;
          var params = {paymentMethod: data.payment_method, token: data.token};
          $this.$http.post(API.Invite.processPayment + DonationId, params).then((res) => {
            var donation = res.body.donation;
            var postback = JSON.parse(donation.postback);
          }, (error) => {
            if(error.body.message){
              $this.msg = error.body.message;
            }else{
              $this.msg = 'Ocorreu um erro no processamento do seu pagamento. Tente novamente.';
            }
            $this.msgShow = true;
            $this.loading = false;
          });
        },
        error: function(err) {
          console.log("ERROR")
          console.log(err)
        },
        close: function() {
          console.log('The modal has been closed.');
        }
      });

      // Obs.: é necessário passar os valores boolean como string
      checkout.open({
        amount: this.integralDonationValue.value * 100,
        buttonText: 'Pagar',
        buttonClass: 'botao-pagamento',
        customerData: 'true',
        createToken: 'false',
        paymentMethods: 'credit_card, boleto',
        uiColor: '#00AE39',
        postbackUrl: API.Invite.processNotification + DonationId,
        items: [{
          "id": DonationId,
          "title": "Doação para " + $this.project.Info.title,
          "unit_price": $this.integralDonationValue + '00',
          "quantity": 1,
          "tangible": "false"
        }]
      });
    },
    hideMsg(){
      this.msgShow = false;
      this.msg = "";
      this.donationModalMsg = "";
      this.donationModalMsgShow = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-dialog{
  margin-top: 300px;
}
#main{
  padding-top: 96px;
}
  .not-found{
    width: 100%;
    text-align: center;
    margin-top: 60px;
    font-size: 30px;
  }

  .not-found-back{
    text-align: center;
    width: 100%;
    a{
      font-size: 28px;
      color: #00ae39;
      text-decoration: none;
      font-weight: bold;
    }
  }
  .project-header{
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: #eee;

    .breadcrumb-list{
      font-family: RalewayBold;

      @media screen and (max-width: 767px ){
        a{
          font-size: 14px;
        }
      }

      ul{
        margin-bottom: 20px;
        list-style: none;
        margin-left: 0px;
        padding: 0;

        li{
          display: inline-block;

          a{
            text-decoration: none;
            color: #434343;
          }

          &.active{
            color: #00ae39;
            font-size: 20px;

          }

          @media screen and (max-width: 767px ){
            &.active {
              clear: both;
              &::before{
                display: none;
              }
            }
            font-size: 14px;
          }

          &.active, &.category{
            &::before{
              padding: 0 5px;
              color: #434343;
              content: ">";
              font-size: 20px;


            }
          }
        }
      }

      .button{
        position: absolute;
        right: 0;
        top: 0;

        @media screen and(max-width: 767px){
          position: initial;
          margin-bottom: 20px;
        }

        .favorite{
          display: block;
          width: 100%;
          padding: 10px;
          padding-top: 5px;
          padding-bottom: 5px;
          text-decoration: none;
          color: #fff;
          border-radius: 5px;
          font-size: 15px;
          font-family: RalewayBold;
          text-align: center;
          border: 2px solid red;
          background-color: red;

          &:hover{
            opacity: 0.7;
          }
        }
      }
    }

    .embed-container {
      position: relative;
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;
      max-width: 100%;

      img{
        width: 100%;
        height: 400px;
        display: block;

        @media screen and (max-width: 991px ){
          height: auto;
        }
      }
    }
    .embed-container iframe, .embed-container object, .embed-container embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      }

    .project-action{
      font-family: RalewayRegular;
      @media screen and(max-width: 767px){
        margin-top: 20px;
      }

      .person-social{
        .contact{
          font-weight: bold;
          color: #00ae39;
        }
      }

      ul{
        list-style: none;
        padding: 0;
      }

      .donations{
        display: block;
        width: 100%;
        position: relative;
        padding: 20px;

        .price-donation{
          display: block;
          width: 150px;
          color: #00ae39;
          font-size: 22px;
          position: absolute;
          left: 0;
          top: 5px;

          @media screen and(max-width: 767px){
            font-size: 22px;
          }
        }
        p{
          display: block;
          position: absolute;
          right: 0;
          top: 10px;
          span{
            font-weight: bold;
            color: #00ae39;
          }
        }
      }

      .actions{
        margin-top: 10px;
        margin-left: 0px;
        margin-right: 0px;

        .button{
          margin-left:0px;

          &.donation{
            width: 100%;
          }
        }

        &.sharing{
          flex-direction: row;
          justify-content: space-between;
          .button{
            width: 49%;
          }
        }

        a{
          display: block;
          width: 100%;
          padding: 15px;
          padding-top: 10px;
          padding-bottom: 10px;
          margin-top: 10px;
          text-decoration: none;
          color: #fff;
          border-radius: 5px;
          font-size: 15px;
          font-family: RalewayBold;
          text-align: center;

          @media screen and(max-width: 991px){
            font-size: 14px;
          }

          &.donate{
            border: 2px solid #0FAE39;
            background-color: #0FAE39;
          }

          &.donate-click{
            border: 2px solid #0FAE39;
            background-color: #fff;
            color: #0FAE39;
          }

          &.discounts{
            border: 2px solid #FD6721;
            background-color: #FD6721;
            padding: 5px;
            padding-top: 10px;
            padding-bottom: 10px;
          }

          &.share-facebook{
            border: 2px solid #3C619C;
            background-color: #3C619C;
          }

          &.share-whatsapp{
            border: 2px solid #0FAE39;
            background-color: #FFF;
            color: #0FAE39;
          }

          &.favorite{
            border: 2px solid #FECF51;
            background-color: #FECF51;
          }

          &.share-email{
            border: 2px solid #ddd;
            color: #777;
          }
          &:hover{
            opacity: 0.7;
          }
        }
      }

    }

    .project-ods{
      padding-bottom: 20px;
      @media screen and(max-width: 767px){
        display: none;
      }

      h2{
        font-size: 18px;
        font-weight: bold;
        margin-top: 5px;
      }
      a{
        display: block;
        width: 100%;
      }
      img{
        display: block;
        width: 100%;
      }
    }

    .carousel{
      width: 100%;

      .slide{
        width: 100%;
        position: relative;
      }
    }
  }

  .project-body{
    margin-top: 20px;
    font-family: RalewayRegular;

    .project-activities{
      padding-top: 30px;
      padding-bottom: 30px;

      h2{
        b{
          color: #0FAE39;
        }
      }

      .activity{
        padding-top: 20px;
        padding-bottom: 20px;
        border-bottom: thin solid #ddd;

        h4{
          font-size: 20px;
        }

        span{
          color: #aaa;
        }
      }
    }



    .project-share{
      button{
        width: 100%;
        padding: 15px;
        font-size: 30px;
        margin-top: 20px;
        font-family: RalewayBold;

        &.facebook-share{
          background-color:#3C619C;
          color: #fff;
        }
        &.email-share{
          border-color: #aaa;
          color: #aaa;
        }
      }
    }

    .project-donations{
      @media screen and(max-width: 767px){
        display: none;
      }
      ul{
        list-style: none;
        padding: 10px;

        li{
          margin-top: 20px;
          img{
            width: 50px;
            border-radius: 50%;
          }
          span{
            font-weight: bold;
            color: #0FAE39;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Project.vue